import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

import MotiveTitle from '../MotiveTitle';
import ProductColorIcon from '../../../../../../../common/icons/icr_preparando_pedido.svg';
import AlarmInProduct from '../../../forms/alarmInProduct/AlarmInProduct';

const AlarmInProductMobile = ({ ...props }) => {
  const { motiveId, product, profile, type, onData } = props;
  return (
    <Box>
      <MotiveTitle
        icon={ProductColorIcon}
        title="Producto"
        subtitle="Producto llegó con alarma"
        mobile
      />
      <AlarmInProduct
        mobile
        motiveId={motiveId}
        type={type}
        product={product}
        profile={profile}
        onData={onData}
      />
    </Box>
  );
};

AlarmInProductMobile.propTypes = {
  motiveId: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  type: PropTypes.string,
  onData: PropTypes.func,
};

export default AlarmInProductMobile;
